import * as Yup from "yup";
import React, {useState} from "react";
import {makeRequired, makeValidate} from "mui-rff";
import {Col, Row} from "reactstrap";
import ValidateMessages from "../../../../../../../../core/models/static/texts/vallidate-messages";
import Dialog from "../../../../../../../components/base/dialog";
import Divider from "@mui/material/Divider";
import Form from "../../../../../../../components/base/form";
import {OutlinedInputForm} from "../../../../../../../components/base/input/outlined_input";
import Button from "../../../../../../../components/base/button/button";
import Api from "../../../../../../../../core/services/api/api";
import useIsMounted from "../../../../../../../hooks/use-is-mounted";
import {deepEqual} from "../../../../../../../../core/services/utils/utils";

const schema = Yup.object().shape({
    name: Yup.string().trim().nullable().required(ValidateMessages.required),
    description: Yup.string().trim().nullable().required(ValidateMessages.required),
});

const subscription = {submitting: true, values: true, initialValues: true, submitErrors: true};

const AddOrEditModal = ({
                            open,
                            setOpen,
                            category,
                            onSuccess,
                        }) => {
    const [loading, setLoading] = useState(false);
    const validate = makeValidate(schema);
    const required = makeRequired(schema);
    const isMounted = useIsMounted();


    /**
     * Prepares the form values to be send to add / edit apis for price matrices.
     * @param values {any} form values
     */
    const onSubmit = (values) => {
        if (category) {
            updateGiftCardCategory(values);
        } else {
            addGiftCardCategory(values);
        }
    }

    /**
     * Adds a gift card category by calling the api from server and if the result is successful, then calls the
     * onSuccess
     * callback with the newly created category as its argument.
     * @param category {any}
     */
    const addGiftCardCategory = (category) => {
        setLoading(true);
        Api.createOrUpdateGiftCardCategory(category).then((response) => {
            if (!isMounted()) return;
            if (response?.resultFlag) {
                onSuccess(response?.data);
                setOpen(false);
            }
            setLoading(false);
        })
    }

    /**
     * Updates a category by calling the api from server and if the result is successful, then calls the onSuccess
     * callback with the updated category as its argument.
     * @param category {any}
     */
    const updateGiftCardCategory = (category) => {
        setLoading(true);
        Api.createOrUpdateGiftCardCategory(category).then((response) => {
            if (!isMounted()) return;
            if (response?.resultFlag) {
                onSuccess(category);
                setOpen(false);
            }
            setLoading(false);
        })
    }

    const colClass = 'mb-4';
    return (
        <Dialog
            open={open}
            setOpen={setOpen}
            loading={loading}
        >
            <Row className='no-gutters align-items-center w-100 transition'>
                <Row xs={12} className='no-gutters justify-content-center m-3 w-100'>
                    <p className='text-lg text-color-1 font-weight-semi-bold text-center'>
                        {category ? 'Edit ' : 'Add '} Gift Card Category
                    </p>
                </Row>
                <Divider className='divider'/>
                <div className='my-3 w-100'/>
                <Form
                    className='w-100'
                    onSubmit={onSubmit}
                    subscription={subscription}
                    validate={validate}
                    initialValues={category}
                    render={({submitting, values, form, initialValues}) => {
                        return (
                            <Row className='no-gutters justify-content-center w-100'>
                                <Row className='no-gutters justify-content-center w-100 mx-3'>
                                    <Col xs={12} className={colClass}>
                                        <OutlinedInputForm
                                            label={'Title'}

                                            name={'name'}
                                            required={required.name}
                                            value={values?.name ?? ''}
                                            onChange={(e) => form.change(e.target.name, e.target.value)}
                                        />
                                    </Col>
                                    <Col xs={12} className={colClass}>
                                        <OutlinedInputForm
                                            minRows={10}
                                            multiline
                                            label={'Description'}

                                            name={'description'}
                                            required={required.description}
                                            value={values?.description ?? ''}
                                            onChange={(e) => form.change(e.target.name, e.target.value)}
                                        />
                                    </Col>
                                </Row>
                                <div className='my-3 w-100'/>
                                <Divider className='divider'/>
                                <Row className='no-gutters justify-content-between align-items-start w-100'>
                                    <Button
                                        disabled={!open || submitting || loading}
                                        variant={'dialog'}
                                        color={'primary'}
                                        onClick={() => setOpen(false)}
                                        borderRadius={'0 8px 0 8px'}
                                    >
                                        {submitting || loading ? "loading..." : 'Close'}
                                    </Button>
                                    <Button
                                        disabled={!open || submitting || loading || (category && deepEqual(values, initialValues))}
                                        variant={'dialog'}
                                        color={'primary'}
                                        type={'submit'}
                                        borderRadius={'8px 0 8px 0'}
                                    >
                                        {submitting || loading ? "loading..." : category ? 'Save' : 'Add'}
                                    </Button>
                                </Row>
                            </Row>
                        );
                    }}
                />
            </Row>
        </Dialog>
    );
}

export default AddOrEditModal;
